import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa";
import { mobilenumber } from '../utiles/constant';

const WhatsAppIcon = () => {
  const [isFooterInView, setIsFooterInView] = useState(false);

  const checkIfFooterInView = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    const footerRect = footer.getBoundingClientRect();
    const isInView = footerRect.top <= window.innerHeight && footerRect.bottom >= 0;
    setIsFooterInView(isInView);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkIfFooterInView);
    checkIfFooterInView(); 
    return () => window.removeEventListener('scroll', checkIfFooterInView);
  }, []);

  return (
    <Link
    to={`https://wa.me/${mobilenumber.phone}`}
    target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 left-4 z-50"
    >
      <FaWhatsapp
        className={`text-5xl ${isFooterInView ? 'text-gray-500' : 'text-green-600'} hover:text-green-700`}
      />
    </Link>
  );
};

export default WhatsAppIcon;
